import Connector from './connector';
import { PBADashboardBalanceSheet as Component } from './PBADashboardBalanceSheet';

export const PBADashboardBalanceSheet = () => <Connector component={Component} />;
